import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { SelectBox } from 'cbc-shared-lib';
import { Subject } from 'rxjs';
import { UsedSgke901aService } from '../../../../../sg-ke-shared/services/used-sgke901a.service';
import { UsedSgke012aService } from '../../../sgke010d/services/used-sgke012a.service';
import { UsedSgke021aService } from '../../services/used-sgke021a.service';

@Component({
  selector: 'app-sgke020d-business-type',
  templateUrl: './sgke020d-business-type.component.html',
  styleUrl: './sgke020d-business-type.component.scss'
})
export class Sgke020dBusinessTypeComponent implements OnInit, OnDestroy {
  /** 登録種別 */
  @Input() registType: string;
  /** 未精算金管理番号 */
  @Input() kakuhoNotarrive: string;
  /** 未精算金履歴番号 */
  @Input() kinkoStatuscode: string;
  /** ラジオボタン変更イベント */
  @Output() changedClsfyEvent = new EventEmitter();
  /** 入金情報クリックイベント */
  @Output() onClickRcvmnyInfoEvent = new EventEmitter();
  /**  返金先確認はがき発行イベント*/
  @Output() clickRpaytoCfrmPostCardEvent = new EventEmitter();
  /** 承認依頼リセット */
  @Output() onClickApprevReqEvent = new EventEmitter();
  /** 戻るボタン処理 */
  @Output() onClickReturnPage = new EventEmitter();
  /** 購読を停止するためのSubject */
  private onDestroy$ = new Subject();
  /** 未精算ステータスコード_保留中 01*/
  private static KINKOSTS_HORYU: string = '01';
  /** 未精算ステータスコード_返金先確認中 02*/
  private static KINKOSTS_HENKAKUTYU = '02';
  /** 未精算ステータスコード_充当確定 03*/
  private static KINKOSTS_JUTO = '03';
  /** 未精算ステータスコード_返金依頼 04*/
  private static KINKOSTS_HENKINIRAI = '04';
  /** 未精算ステータスコード_返金承認 05*/
  private static KINKOSTS_HENKINSHONIN = '05';
  /** 未精算ステータスコード_振替依頼 06*/
  private static KINKOSTS_FURIKAEIRAI = '06';
  /** 未精算ステータスコード_精算済 07*/
  private static KINKOSTS_SEISANZUMI = '07';
  /** 未精算ステータスコード_不能依頼 08*/
  private static KINKOSTS_FUNOIRAI = '08';
  /** ラジオボタン_入金消込 1 */
  public static REGISTTYPE_NYUKIN = '1';
  /** ラジオボタン_振替 2 */
  public static REGISTTYPE_FURIKAE = '2';
  /** ラジオボタン_返金 3 */
  public static REGISTTYPE_HENKIN = '3';
  /** ラジオボタン_返金結果登録 4 */
  public static REGISTTYPE_HENKAKU = '4';
  /** ラジオボタン_充当 5 */
  public static REGISTTYPE_JUTO = '5';
  /**
   * 入金種別
   * @type {SelectBox[]}
   * @memberof Sgke020dBusinessTypeComponent
   */
  registTypeList: SelectBox[] = [
    { value: Sgke020dBusinessTypeComponent.REGISTTYPE_NYUKIN, viewValue: '入金消込' },
    { value: Sgke020dBusinessTypeComponent.REGISTTYPE_FURIKAE, viewValue: '振替' },
    { value: Sgke020dBusinessTypeComponent.REGISTTYPE_HENKIN, viewValue: '返金' },
    { value: Sgke020dBusinessTypeComponent.REGISTTYPE_HENKAKU, viewValue: '返金結果登録' },
    { value: Sgke020dBusinessTypeComponent.REGISTTYPE_JUTO, viewValue: '充当' },
  ];

  /**
   * コンストラクタ
   * @param {UsedSgke012aService} searchService
   * @param {UsedSgke021aService} usedSgke021aService
   * @param {UsedSgke901aService} usedSgke901sService
   * @memberof Sgke020dBusinessTypeComponent
   */
  constructor(
    public searchService: UsedSgke012aService,
    public usedSgke021aService: UsedSgke021aService,
    public usedSgke901sService: UsedSgke901aService,
  ) { }
  /**
   * 初期処理
   * @memberof Sgke020dBusinessTypeComponent
   */
  ngOnInit(): void {
  }
  /**
   * 終了時処理
   * @memberof Sgke020dBusinessTypeComponent
   */
  ngOnDestroy(): void {
    this.onDestroy$.next();
  }

  /**
   * ラジオボタン非活性化処理
   * @param registType
   * @param {string} registType
   * @return {enabled}  {boolean}
   * @memberof Sgke020dBusinessTypeComponent
   */
  getDisabled(registType: string): boolean {
    let enabled = false;
    // 確報未着
    const kakuhoNotarrive = this.kakuhoNotarrive;
    // 未精算ステータスコード
    const status = this.kinkoStatuscode;
    // 未精算ステータスコードで判定
    switch (status) {
      //保留中
      case Sgke020dBusinessTypeComponent.KINKOSTS_HORYU:
        // 保留中＋確報未着なし
        if (kakuhoNotarrive == null) {
          //返金結果登録のみ非活性
          enabled = ![Sgke020dBusinessTypeComponent.REGISTTYPE_HENKAKU].includes(registType);
          // 保留中＋確報未着あり
        } else {
          //入金消込、充当のみ活性化
          enabled = [Sgke020dBusinessTypeComponent.REGISTTYPE_NYUKIN, Sgke020dBusinessTypeComponent.REGISTTYPE_JUTO].includes(registType);
        }
        break;
      // 充当
      case Sgke020dBusinessTypeComponent.KINKOSTS_JUTO:
        //充当のみ活性
        enabled = [Sgke020dBusinessTypeComponent.REGISTTYPE_JUTO].includes(registType);
        break;
      //返金先確認中
      case Sgke020dBusinessTypeComponent.KINKOSTS_HENKAKUTYU:
        // 返金先確認依頼＋確報未着なし
        if (kakuhoNotarrive == null) {
          //返金ラジオボタンのみ活性
          enabled = [Sgke020dBusinessTypeComponent.REGISTTYPE_HENKIN].includes(registType);
          // 返金先確認依頼＋確報未着あり
        } else {
          // 入金消込、充当のみ活性化
          enabled = [Sgke020dBusinessTypeComponent.REGISTTYPE_NYUKIN, Sgke020dBusinessTypeComponent.REGISTTYPE_JUTO].includes(registType);
        }
        break;
      //返金承認
      case Sgke020dBusinessTypeComponent.KINKOSTS_HENKINSHONIN:
        //返金結果登録のみ活性
        enabled = [Sgke020dBusinessTypeComponent.REGISTTYPE_HENKAKU].includes(registType);
        break;
      //返金依頼
      case Sgke020dBusinessTypeComponent.KINKOSTS_HENKINIRAI:
      //振替依頼
      case Sgke020dBusinessTypeComponent.KINKOSTS_FURIKAEIRAI:
      //精算済
      case Sgke020dBusinessTypeComponent.KINKOSTS_SEISANZUMI:
      //不能依頼
      case Sgke020dBusinessTypeComponent.KINKOSTS_FUNOIRAI:
      default:
        enabled = false;
    }
    // 現在選択状態のものが無効な場合は選択解除する
    if (this.registType == registType && enabled == false) {
      setTimeout(() => this.changedClsfyEvent.emit(null));
    }
    return !enabled;
  };
  /**
   * ボタン非活性化処理
   * @param {any} button
   * @return {enabled} boolean 
   * @memberof Sgke020dBusinessTypeComponent
   */
  getDisabledButton(button) {
    let enabled = false;
    // 未精算ステータスコード
    const status = this.kinkoStatuscode;
    switch (button) {
      // 返金先確認はがき発行ボタン
      case 'postCard':
        enabled = [Sgke020dBusinessTypeComponent.KINKOSTS_HORYU, Sgke020dBusinessTypeComponent.KINKOSTS_HENKAKUTYU].includes(status); //保留中、返金先確認中のみ活性
        break;
      // 承認依頼リセットボタン
      case 'reset':
        enabled = [Sgke020dBusinessTypeComponent.KINKOSTS_HENKINIRAI, Sgke020dBusinessTypeComponent.KINKOSTS_FURIKAEIRAI].includes(status); //返金依頼、振替依頼、不能依頼のみ活性
        break;
      // 入金情報
      case 'rcvmnyInfo':
      default:
        enabled = true;
        break;
    }
    return !enabled;
  }
  /**
   * ラジオボタン押下時
   * @param {*} event
   * @memberof Sgke020dBusinessTypeComponent
   */
  onChangeRadio(event: any): void {
    this.changedClsfyEvent.emit(event);
  }
  /**
   * 戻るボタン押下時処理
   * @memberof Sgke020dBusinessTypeComponent
   */
  returnPage() {
    /** 戻るイベント */
    this.onClickReturnPage.emit();
  }
  /**
   *　入金情報押下時処理
   * @memberof Sgke020dBusinessTypeComponent
   */
  onClickRcvmnyInfo() {
    this.onClickRcvmnyInfoEvent.emit();
  }
  /**
   * 返金先確認はがき発行ボタン押下時処理
   * @param event 返金先確認はがき発行ボタン
   * @memberof Sgke020dBusinessTypeComponent
   */
  onClickRpaytoCfrmPostCard() {
    this.clickRpaytoCfrmPostCardEvent.emit();
  }
  /**
   * 承認依頼リセット押下時処理
   * @memberof Sgke020dBusinessTypeComponent
   */
  onClickReset(): void {
    this.onClickApprevReqEvent.emit();
  }

}
